<template>
  <v-menu
    bottom
    left
    min-width="100"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        icon
        outlined
        color="primary"
        v-bind="attrs"
        class="mt-1"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      class="pa-0"
    >
      <v-divider />
      <v-list-item
        :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
        @click="remove()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="error"
          >
            mdi-delete
          </v-icon>
          Delete
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
        @click="publish()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="success"
          >
            mdi-reload
          </v-icon>
          Publish
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
  name: "ContactlessOptions",
  mixins: [failure],
  props: {
    accountId: {
      type: Number,
      required: true
    },
    contactlessId: {
      type: Number,
      required: true
    }
  },
  methods: {
    remove() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to delete?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .delete(
              `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless/${this.contactlessId}`
            )
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    publish() {
      this.$http
        .put(
          `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless/${this.contactlessId}/publish`
        )
        .then(
          (data) => {
            this.handleSuccess(data.body);
          },
          (failure) => {
            this.handleFailure(failure);
          }
        );
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    }
  }
};
</script>
